import React from 'react';
import { Query } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import gql from 'graphql-tag';
import { Loading } from '../../../components/Loading';
import SurveyDetail from './SurveyDetail';
import { matchShape } from '../../../components/prop-types';

const SURVEY_QUERY = gql`
  query surveyDetailQuery($accountId: ID!, $id: ID!) {
    account(id: $accountId) {
      id
      survey(id: $id) {
        id
        name
        tags
        createdOn
        updatedOn
        statuses
        template {
          id
          title
        }
        self {
          ...surveyRespondent
        }
        managers {
          ...surveyRespondent
        }
        peers {
          ...surveyRespondent
        }
        directReports {
          ...surveyRespondent
        }
        others {
          ...surveyRespondent
        }
        commentsEnabled
      }
    }
  }
  fragment surveyRespondent on SurveyRespondent {
    respondent {
      id
      firstName
      lastName
      email
    }
    startUrl
    previewInviteUrl
    previewReminderUrl
    id
    status
  }
`;

const SurveyDetailContainer = (props) => {
  const { match } = props;
  const { aid, surveyId } = match.params;
  const variables = {
    accountId: aid,
    id: surveyId,
  };
  return (
    <Query query={SURVEY_QUERY} variables={variables}>
      {({ loading, error, data }) => {
        if (error) {
          return `Error ${error.message}`;
        }

        if (loading) {
          return <Loading />;
        }

        return (
          <SurveyDetail data={data} />
        );
      }}
    </Query>
  );
};

SurveyDetailContainer.propTypes = {
  match: matchShape.isRequired,
};

export default withRouter(SurveyDetailContainer);
